export const MAP_STYLE_DARK_MODE = 'mapbox://styles/mapbox/dark-v11';
export const MAP_STYLE_LIGHT_MODE = 'mapbox://styles/mapbox/light-v11';
